// containers/Auth/LoginPage.tsx
import React from 'react';

const Unauthorised: React.FC = () => {
  return (
    <div>
      <h1>Unauthorised</h1>
    </div>
  );
};

export default Unauthorised;
